/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetYoutubeIntegrationStatsCountryViewersQueryResponse, GetYoutubeIntegrationStatsCountryViewersPathParams, GetYoutubeIntegrationStatsCountryViewersQueryParams } from "../models/GetYoutubeIntegrationStatsCountryViewers";

export function getGetYoutubeIntegrationStatsCountryViewersUrl(station: GetYoutubeIntegrationStatsCountryViewersPathParams["station"]) {
  const res = { method: 'GET', url: `/youtube-stats/viewers/${station}/country` as const }
  return res
}

/**
 * @description Returns stats for every channel in the live-viewers catalog whose `countryCode` matches this station’s channel. `metadata.channels[*].isSelf` marks this station’s `youtubeChannelId`.
 * @summary Viewer time series for same-country catalog channels
 * {@link /youtube-stats/viewers/:station/country}
 */
export async function getYoutubeIntegrationStatsCountryViewers(station: GetYoutubeIntegrationStatsCountryViewersPathParams["station"], params: GetYoutubeIntegrationStatsCountryViewersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetYoutubeIntegrationStatsCountryViewersQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetYoutubeIntegrationStatsCountryViewersUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}